import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import RoundClear from 'react-md-icon/dist/RoundClear';
import {
  ModalBox,
  ModalContainer,
  PseudoContainer,
  ModalTitleContainer,
  ModalTitle,
  ModalBody,
  CloseButton,
} from './elements';

class SideModal extends Component {
  render() {
    const { closeButton, title, children } = this.props;

    return ReactDOM.createPortal(
      <ModalContainer>
        <ModalBox>
          <CloseButton onClick={closeButton}>
            <RoundClear />
          </CloseButton>
          <ModalTitleContainer>
            <ModalTitle>{title}</ModalTitle>
          </ModalTitleContainer>
          <ModalBody>{children}</ModalBody>
        </ModalBox>
        <PseudoContainer onClick={closeButton} />
      </ModalContainer>,
      document.getElementById('modal'),
    );
  }
}

SideModal.propTypes = {
  closeButton: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
};

export default SideModal;
